import { Component, OnInit } from '@angular/core';
import { DeviceService } from '../../services/device/device.service';
import { UserService } from '../../services/user/user.service';
import { ConstantsService } from '../../services/utils/constants.service';
import Swal from 'sweetalert2';

declare var $: any;
declare var mApp: any;

@Component({
    selector: 'app-device',
    templateUrl: './device.component.html',
    styleUrls: ['./device.component.css']
})
export class DeviceComponent implements OnInit {
    public allDevices: any[] = [];
    private datatable: any;
    public isDeveloper: boolean = false;
    public isSuper: boolean = false;
    public isAdmin: boolean = false;
    public selectedDevices: any[] = [];
    public currentSelectedDevice: any = {};

    constructor(private constantsService: ConstantsService,
        private deviceService: DeviceService, private userService: UserService) { }

    ngOnInit() {
        mApp.block('#m_table_1', {
            overlayColor: '#000000',
            type: 'loader',
            state: 'success',
            message: 'Please wait...'
        });

        this.userService.getMe().subscribe(
            (response) => {
                // if reached here, it means the response is success
                let me = response.value;
                if (me.role == this.constantsService.ROLE_DEVELOPER) {
                    this.isDeveloper = true;
                    this.isSuper = true;
                    this.isAdmin = true;
                }

                if (me.role == this.constantsService.ROLE_SUPER_ADMIN) {
                    this.isDeveloper = false;
                    this.isSuper = true;
                    this.isAdmin = true;
                }

                if (me.role == this.constantsService.ROLE_ADMIN) {
                    this.isDeveloper = false;
                    this.isSuper = false;
                    this.isAdmin = true;
                }
            },
            (err) => {
                // if reached here, it means the response is error
            });

        this.getAllDevices();
    }

    getAllDevices(): void {
        this.deviceService.getAllDevices().subscribe(
            (response) => {
                // if reached here, it means the response is success
                this.allDevices = response.value;
                if (this.datatable) {
                    this.datatable.clear();
                    this.datatable.destroy();
                    // this.datatable.draw();
                }
                this.InitTable();
                mApp.unblock('#m_table_1');
            },
            (err) => {
                // if reached here, it means the response is error
                this.allDevices = [];
                if (this.datatable) {
                    this.datatable.clear();
                    this.datatable.destroy();
                    // this.datatable.draw();
                }
                this.InitTable();
                mApp.unblock('#m_table_1');
            });
    }

    public exportCSV(): void {
        const devices = this.datatable
            ? this.datatable.rows({ search: 'applied', order: 'applied' }).data().toArray()
            : this.allDevices;
        const headers = ['Name', 'Mac Address', 'Type', 'Apartment', 'Room', 'Client', 'Gateway', 'State'];
        const rows = devices.map(device => [
            device.name, device.mac_address, device.device_type, device.apartment,
            device.room, device.client, device.gateway,
            device.state === this.constantsService.DEVICE_STATE_ONLINE ? 'Online'
                : device.state === this.constantsService.DEVICE_STATE_OFFLINE ? 'Offline' : 'Unknown'
        ]);
        const escapeCell = (value: any): string => {
            let text = value == null ? '' : String(value);
            // Keep spreadsheet applications from interpreting device names as formulas.
            if (/^[\s]*[=+\-@]/.test(text)) {
                text = "'" + text;
            }
            return '"' + text.replace(/"/g, '""') + '"';
        };
        const csv = [headers].concat(rows).map(row => row.map(escapeCell).join(',')).join('\r\n');
        const blob = new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'devices-' + new Date().toISOString().replace(/[:.]/g, '-') + '.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    }

    InitTable(): void {
        let self = this;
        // begin first table
        this.datatable = $('#m_table_1').DataTable({
            data: this.allDevices,
            responsive: true,
            paging: true,
            //== DOM Layout settings
            dom: "<'row'<'col-sm-12'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

            pageLength: 10,

            language: {
                'lengthMenu': 'Display _MENU_',
            },

            //== Order settings
            order: [[1, 'desc']],

            headerCallback: function(thead, data, start, end, display) {
                thead.getElementsByTagName('th')[0].innerHTML = `
                        <label class="m-checkbox m-checkbox--single m-checkbox--solid m-checkbox--brand">
                            <input type="checkbox" value="" class="m-group-checkable">
                            <span></span>
                        </label>`;
            },

            columnDefs: [
                {
                    targets: 0,
                    data: "id",
                    width: '30px',
                    className: 'dt-right',
                    orderable: false,
                    render: function(data, type, full, meta) {
                        return `
                            <label id="` + full.id + `" class="m-checkbox m-checkbox--single m-checkbox--solid m-checkbox--brand">
                                <input type="checkbox" value="" class="m-checkable">
                                <span></span>
                            </label>`;
                    },
                },
                {
                    targets: 1,
                    data: "name",
                    title: "Name",
                    className: "text-center",
                },
                {
                    targets: 2,
                    data: "mac_address",
                    title: "Mac Address",
                    className: "text-center"
                },
                {
                    targets: 3,
                    data: "device_type",
                    title: "Type",
                    className: "text-center"
                },
                {
                    targets: 4,
                    data: "apartment",
                    title: "Apartment",
                    className: "text-center"
                },
                {
                    targets: 5,
                    data: "room",
                    title: "Room",
                    className: "text-center"
                },
                {
                    targets: 6,
                    data: "client",
                    title: "Client",
                    className: "text-center"
                },
                {
                    targets: 7,
                    data: "gateway",
                    title: "Gateway",
                    className: "text-center"
                },
                {
                    targets: 8,
                    data: "state",
                    title: "State",
                    className: "text-center",
                    render: function(data, type, full, meta) {
                        // Sort, filter and type-detect on the raw state, only display the badge
                        if (type !== 'display') {
                            return data ? data : '';
                        }
                        var status = {
                            0: { 'title': 'Online', 'class': 'm-badge--success' },
                            1: { 'title': 'Offline', 'class': ' m-badge--danger' },
                            2: { 'title': 'Unknown', 'class': ' m-badge--metal' },
                        };
                        // if (typeof status[data] === 'undefined') {
                        //     return data;
                        // }
                        let location: number = 0;
                        if (data == self.constantsService.DEVICE_STATE_ONLINE) {
                            location = 0;
                        } else if (data == self.constantsService.DEVICE_STATE_OFFLINE) {
                            location = 1;
                        } else {
                            location = 2;
                        }
                        return '<span class="m-badge ' + status[location].class + ' m-badge--wide">' + status[location].title + '</span>';
                    },
                },
                {
                    targets: 9,
                    width: '100px',
                    title: 'Actions',
                    orderable: false,
                    className: "text-center",
                    render: function(data, type, full, meta) {
                        return `
                            <a href="javascript:void(0);" id="`+ full.id + `" class="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" title="Remove">
                              <i class="la la-trash"></i>
                            </a>`;
                    },
                }
            ],
        });

        this.datatable.on('change', '.m-group-checkable', function() {
            var set = $(this).closest('table').find('td:first-child .m-checkable');
            var checked = $(this).is(':checked');

            $(set).each(function() {
                if (checked) {
                    $(this).prop('checked', true);
                    $(this).closest('tr').addClass('active');
                }
                else {
                    $(this).prop('checked', false);
                    $(this).closest('tr').removeClass('active');
                }
            });

            if (checked) {
                for (let i = 0; i < self.allDevices.length; i++) {
                    self.selectedDevices[i] = self.allDevices[i].id;
                }
            } else {
                self.selectedDevices = [];
            }
        });

        this.datatable.on('change', 'tbody tr .m-checkbox', function() {
            let id = $(this).attr('id');

            let isChecked = $(this).parents('tr').find('td:first-child .m-checkable').is(':checked');

            if (isChecked) {
                //return index of element, if not found it will return -1
                let found = $.inArray(id, self.selectedDevices);
                if (found < 0) {
                    // Element was not found, add it.
                    self.selectedDevices.push(id);
                }
            } else {
                // return index of element, if not found it will return -1
                let found = $.inArray(id, self.selectedDevices);
                if (found >= 0) {
                    // Element was found, remove it.
                    self.selectedDevices.splice(found, 1);
                }
            }
        });

        $('#m_table_1').on('click', 'a.m-portlet__nav-link', function() {
            let id = $(this).attr('id');
            self.DeleteDevice(id);
        });
    }

    public DeleteDevice(id: string): void {
        if (!this.isAdmin) {
            Swal(
                'Unauthorized',
                'You are not allowed to perform this operation',
                'error'
            )

            return;
        }
        let self = this;
        Swal({
            title: 'Are you sure?',
            text: 'You will not be able to recover device again!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
        }).then((result) => {
            if (result.value) {
                self.deviceService.deleteDeviceId(id).subscribe(
                    (response) => {
                        self.getAllDevices();
                        // Swal(
                        //     'Deleted!',
                        //     'Device has been deleted.',
                        //     'success'
                        // );
                    }, (err) => {
                        self.getAllDevices();
                        Swal(
                            'Cancelled',
                            err._body,
                            'error'
                        )
                    }
                );
                // For more information about handling dismissals please visit
                // https://sweetalert2.github.io/#handling-dismissals
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                // Swal(
                //     'Cancelled',
                //     'Your imaginary file is safe :',
                //     'error'
                // )
            }
        })
    }

    public DeleteDevices(): void {
        if (!this.isAdmin) {
            Swal(
                'Unauthorized',
                'You are not allowed to perform this operation',
                'error'
            )

            return;
        }
        let self = this;
        Swal({
            title: 'Are you sure?',
            text: 'You will not be able to recover those devices again!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
        }).then((result) => {
            if (result.value) {
                self.deviceService.deleteDevices(self.selectedDevices).subscribe(
                    (response) => {
                        self.getAllDevices();
                        // Swal(
                        //     'Deleted!',
                        //     'Device has been deleted.',
                        //     'success'
                        // );
                    }, (err) => {
                        self.getAllDevices();
                        Swal(
                            'Cancelled',
                            'Error occured and devices were not deleted',
                            'error'
                        )
                    }
                );
                // For more information about handling dismissals please visit
                // https://sweetalert2.github.io/#handling-dismissals
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                // Swal(
                //     'Cancelled',
                //     'Your imaginary file is safe :',
                //     'error'
                // )
            }
        })
    }

}
